import Logo from '@assets/icon.svg';
import { FC } from 'react';

export const AppLogo: FC<{ size?: number }> = ({ size = 32 }) => {
  return (
    <div
      className="flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <img
        src={Logo}
        alt="SmartPOS Logo"
        style={{ width: size, height: size }}
      />
    </div>
  );
};
